export const PESQUISA_ESCALAS = 'PESQUISA_ESCALAS';
export const PESQUISA_ESCALAS_START = 'PESQUISA_ESCALAS_START';
export const PESQUISA_ESCALAS_ERROR = 'PESQUISA_ESCALAS_ERROR';
export const PESQUISA_ESCALAS_SUCCESS = 'PESQUISA_ESCALAS_SUCCESS';

export const FILTRAR_ESCALAS = 'FILTRAR_ESCALAS';
export const RESETAR_ESCALAS = 'RESETAR_ESCALAS';
